export default "__VITE_ASSET__Ce06nUeY__"